import footerBg from './footerBg.png';
export { footerBg };
